<ui-results-item [icon]="icon()" [ergebnis]="ergebnis()">
  <ng-container right-side>
    <div class="flex gap-4 flex-wrap items-center">
      <div class="text-cp-error-100 flex gap-2">
        <mat-icon svgIcon="cp-info" class="icon-info-error" />
        <div>Fehler Webservice</div>
      </div>
      <div
        class="font-bold underline text-cp-error-100 cursor-pointer"
        (click)="openTarifErrorDialog()"
      >
        Anzeigen
      </div>
    </div>
  </ng-container>
</ui-results-item>
